import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Header from "../../compnents/Header";
import Footer from "../../compnents/Footer";
import RoomBG from "../../assets/images/room-bg2.jpg";

import constantV1 from "../../utils/constantV1";
import "./room.scss";
import RoomV2 from "./RoomV2";

function Room() {
  const [step, setStep] = useState(1);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [errors, setErrors] = useState({});
  const [rooms, setRooms] = useState([]);

  const location = useLocation();
  // console.log("location:::", location.state)
  const { loginResponse } = useSelector((state) => state.AuthReducer);
  const user = loginResponse?.data || {};

  const [formData, setFormData] = useState({
    hostName: "",
    department: "",
    contactNumber: "",
    bookedBy: "",
    employeeCode: "",
    priority: "",
    meetingType: "",
    allocationDate: "",
    timeFrom: "",
    timeTo: "",
    vcRequired: "false",
    participants: "",
    bookingSubject: "",
    bookingDescription: "",
    purposeTag: "",
    setupStyle: "",
    file: null,
  });

  // Pre-fill form with logged-in user data
  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        hostName: user.name || "",
        department: user.department || "",
        contactNumber: user.mobile_no || "",
        bookedBy: user.name || "",
        employeeCode: user.employee_code || "",
      }));
    }
  }, [user]);

  // Input change handler
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};

    if (!selectedRoom?.roomId) newErrors.room_id = "Please select a room";
    if (!formData.employeeCode)
      newErrors.employee_code = "Employee code is required";
    if (!formData.allocationDate)
      newErrors.allocation_date = "Booking date is required";
    if (!formData.timeFrom) newErrors.time_from = "Start time is required";
    if (!formData.timeTo) newErrors.time_to = "End time is required";
    if (!formData.bookingSubject)
      newErrors.booking_subject = "Booking subject is required";
    if (!formData.meetingType)
      newErrors.meeting_type = "Meeting type is required";
    if (!formData.priority) newErrors.priority = "Priority is required";
    if (!formData.contactNumber)
      newErrors.contact_number = "Contact number is required";
    if (!formData.hostName) newErrors.host_name = "Host name is required";
    if (!formData.department) newErrors.department = "Department is required";
    if (!formData.participants)
      newErrors.participants = "At least one participant email is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Navigation
  const handleNext = () => {
    if (!selectedRoom) {
      setErrors({ room_id: "Please select a room" });
      return;
    }
    setStep((prev) => prev + 1);
  };

  const handleBack = () => setStep((prev) => prev - 1);

  // Submit booking
const handleSubmit = async (e) => {
  e.preventDefault(); // prevent default form submit

  // Validate
  if (!validateForm()) return;

  if (!selectedRoom?.roomId) {
    setErrors({ room_id: "Please select a room" });
    setStep(1); // Go back to step 1 if room not selected
    return;
  }

  const payload = {
    roomId: selectedRoom.roomId, // ensure this is correct
    employeeCode: formData.employeeCode,
    allocationDate: formData.allocationDate,
    timeFrom: formData.timeFrom,
    timeTo: formData.timeTo,
    bookingSubject: formData.bookingSubject,
    bookingDescription: formData.bookingDescription,
    meetingType: formData.meetingType,
    vcRequired: formData.vcRequired === "true",
    participants: formData.participants
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean),
    repeatBooking: "none",
    attachments: formData.file ? [formData.file.name] : [],
    setupStyle: formData.setupStyle || "Conference",
    contactNumber: formData.contactNumber,
    hostName: formData.hostName,
    department: formData.department,
    purposeTag: formData.purposeTag
      ? formData.purposeTag.split(",").map((p) => p.trim())
      : [],
    priority: formData.priority,
    bookedBy: user.employee_code || "",
  };

  try {
    const res = await fetch(`${constantV1.BASE_URL}/room/bookings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginResponse?.data?.session?.access_token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data.message || "Booking failed");

    alert("Room booked successfully!");
    setStep(1);
    setSelectedRoom(null);
    setFormData({
      hostName: user.name || "",
      department: user.department || "",
      contactNumber: user.mobile_no || "",
      bookedBy: user.name || "",
      employeeCode: user.employee_code || "",
      priority: "",
      meetingType: "",
      allocationDate: "",
      timeFrom: "",
      timeTo: "",
      vcRequired: "false",
      participants: "",
      bookingSubject: "",
      bookingDescription: "",
      purposeTag: "",
      setupStyle: "",
      file: null,
    });
  } catch (error) {
    console.error("Booking error:", error);
    alert(error.message);
  }
};


  // Fetch room list
  useEffect(() => {
    async function fetchRooms(token) {
      try {
        const res = await fetch(
          `https://dotconnect.dotandkey.com/api/v1/room/AllRoom`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to fetch rooms");
        setRooms(data);
      } catch (err) {
        console.error("fetchRooms error:", err.message);
      }
    }

    const token = loginResponse?.data?.session?.access_token;
    if (token) fetchRooms(token);
  }, [loginResponse]);

  // Room list from location
  const roomData = rooms?.data?.rooms || [];


  // console.log("rooms:::", location.state)

  const getUniqueRooms = (data, key) => {
    const seen = new Set();
    return data.filter((item) => {
      const val = item[key];
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    });
  };

  const uniqueRoomTypes = getUniqueRooms(roomData, "roomType");
  const filteredRooms = selectedType
    ? roomData.filter((room) => room.roomType === selectedType && room.isAvailable === true)
    : roomData;
// console.log("roomid:::", rooms?.data?.rooms);
return (
  <div>

    <Header />
    <Container fluid>
      <Row>
        {/* Banner */}
        <Col md={6} className="ps-0 pe-sm-0 ggb">
          <div className="room-banner">
            <img src={RoomBG} alt="Room Banner" />
            <h2>
              Meeting <span>Room Booking</span>
            </h2>
          </div>
        </Col>

        {/* Form */}
        <Col md={6}>
          <div className="form-wrapper">
            <h4 className="py-3 w-100 text-center">
              It's 2 easy steps to book a room
            </h4>

            {/* Stepper */}
            <div className="progress-box">
              <div className="stepper d-flex justify-content-between mb-4">
                {[1, 2].map((s) => (
                  <div
                    key={s}
                    style={{ color: step === s ? "#67058a" : "#000" }}
                  >
                    <div
                      className={`rounded-circle ${
                        step === s ? "active" : ""
                      }`}
                    >
                      {s}
                    </div>
                    Step {s}
                  </div>
                ))}
              </div>
              <div className="progress mb-4" style={{ height: "6px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${(step - 1) * 100}%`,
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
            </div>

            {/* Step 1 */}
            {step === 1 && (
              <Col md={12}>
                <div className="room-box text-center">
                  <div className="room-wrap">
                    {/* Filter */}
                    <div className="d-flex justify-content-end mb-3">
                      <p className="me-3">Filter</p>
                      <select
                        onChange={(e) => setSelectedType(e.target.value)}
                      >
                        <option value="">All</option>
                        {uniqueRoomTypes.map((room, idx) => (
                          <option key={idx} value={room.roomType}>
                            {room.roomType}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Rooms */}
                    <ul>
                      {filteredRooms?.map((room) => (
                        <li
                          key={room.roomId || room.roomNumber}
                          className="m-2"
                        >
                          <button
                            className={`each-room p-3 ${
                              selectedRoom?.roomNumber === room.roomNumber
                                ? "active"
                                : ""
                            } ${room.isAvailable ? "true" : "false"}`}
                            onClick={() => setSelectedRoom(room)}
                            disabled={!room.isAvailable}
                          >
                            <div className="room-header">
                              <p className="floor">
                                <span>Floor</span> {room.floorNo}
                              </p>
                              <p className="available">
                                <span>
                                  {room.isAvailable
                                    ? "Available"
                                    : "Unavailable"}
                                </span>
                              </p>
                            </div>
                            <h5>{room.roomNumber}</h5>
                            <div className="room-footer">
                              <p className="type">
                                <span>Type</span> {room.roomType}
                              </p>
                              <p className="capacity">
                                <span>Pax</span> {room.capacity}
                              </p>
                            </div>
                          </button>
                        </li>
                      ))}
                    </ul>

                    <p className="tilt">Select any room</p>
                    {errors.room_id && (
                      <p className="text-danger">{errors.room_id}</p>
                    )}
                    <Button
                      disabled={!selectedRoom}
                      onClick={handleNext}
                      className="mt-4"
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Col>
            )}

            {/* Step 2 */}
            {step === 2 && (
              <div className="form-wrapper-sec">
                <Form onSubmit={handleSubmit}>
                  <fieldset>
                    <legend>Meeting Details</legend>
                    <Row>
                      <Col md={6} className="mt-2">
                        <Form.Label>Host Name</Form.Label>
                        <Form.Control
                          name="hostName"
                          value={formData.hostName}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.host_name && (
                          <p className="text-danger">{errors.host_name}</p>
                        )}
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Label>Department</Form.Label>
                        <Form.Control
                          name="department"
                          value={formData.department}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.department && (
                          <p className="text-danger">{errors.department}</p>
                        )}
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          name="contactNumber"
                          value={formData.contactNumber}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.contact_number && (
                          <p className="text-danger">
                            {errors.contact_number}
                          </p>
                        )}
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Label>Room No</Form.Label>
                        <Form.Control
                          name="roomId"
                          value={selectedRoom?.roomNumber || ""}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.room_id && (
                          <p className="text-danger">{errors.room_id}</p>
                        )}
                      </Col>
                      <Col md={4} className="mt-2">
                        <Form.Label>Booking Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="allocationDate"
                          value={formData.allocationDate}
                          onChange={handleChange}
                        />
                        {errors.allocation_date && (
                          <p className="text-danger">
                            {errors.allocation_date}
                          </p>
                        )}
                      </Col>
                      <Col md={4} className="mt-2">
                        <Form.Label>Time From</Form.Label>
                        <Form.Control
                          type="time"
                          name="timeFrom"
                          value={formData.timeFrom}
                          onChange={handleChange}
                        />
                        {errors.time_from && (
                          <p className="text-danger">{errors.time_from}</p>
                        )}
                      </Col>
                      <Col md={4} className="mt-2">
                        <Form.Label>Time To</Form.Label>
                        <Form.Control
                          type="time"
                          name="timeTo"
                          value={formData.timeTo}
                          onChange={handleChange}
                        />
                        {errors.time_to && (
                          <p className="text-danger">{errors.time_to}</p>
                        )}
                      </Col>
                    </Row>
                  </fieldset>

                  <fieldset className="my-5">
                    <legend>Booking Summary</legend>
                    <Row>
                      <Col md={12} className="mt-2">
                        <Form.Label>
                          Participants (comma-separated emails)
                        </Form.Label>
                        <Form.Control
                          name="participants"
                          value={formData.participants}
                          onChange={handleChange}
                        />
                        {errors.participants && (
                          <p className="text-danger">{errors.participants}</p>
                        )}
                      </Col>
                      <Col md={12} className="mt-2">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                          name="bookingSubject"
                          value={formData.bookingSubject}
                          onChange={handleChange}
                        />
                        {errors.booking_subject && (
                          <p className="text-danger">
                            {errors.booking_subject}
                          </p>
                        )}
                      </Col>
                      <Col md={12} className="mt-2">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="bookingDescription"
                          value={formData.bookingDescription}
                          onChange={handleChange}
                        />
                      </Col>

                      <Col
                        md={12}
                        className="d-flex justify-content-between my-4"
                      >
                        <Button onClick={handleBack}>Back</Button>
                        <Button type="submit" variant="success" onClick={handleSubmit}>
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                </Form>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
    <Footer />
  </div>
);

}

export default Room;
